import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

export const getPauseReasons = async () => {
  const response = await fetchWrapper(hcUrl('/pauses'), buildOpts());

  return handleResponse(response);
};
